'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _reactScroll = require('react-scroll');
var _OMTextArea = require('../../OMComponents/OMTextArea/OMTextArea');var _OMTextArea2 = _interopRequireDefault(_OMTextArea);
var _MessageBlock = require('./components/MessageBlock/MessageBlock');var _MessageBlock2 = _interopRequireDefault(_MessageBlock);
var _MessageForm = require('./components/MessageForm/MessageForm');var _MessageForm2 = _interopRequireDefault(_MessageForm);
var _MessagesList = require('./components/MessagesList/MessagesList');var _MessagesList2 = _interopRequireDefault(_MessagesList);
var _contants = require('./contants');var _contants2 = _interopRequireDefault(_contants);

var _MessageFromCompany = require('./MessageFromCompany.scss');var styles = _interopRequireWildcard(_MessageFromCompany);
var _constants = require('../../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

MessageFromCompanyComponent = function (_Component) {_inherits(MessageFromCompanyComponent, _Component);function MessageFromCompanyComponent() {var _temp, _this, _ret;_classCallCheck(this, MessageFromCompanyComponent);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isOpen: false,
      view: (0, _isEmpty2.default)(_this.props.messages) && _this.props.isOwner ? _contants2.default.empty : _contants2.default.messages,
      selectedMessageId: null }, _this.


    handleClick = function () {
      _this.setState(function (prevState) {return { isOpen: !prevState.isOpen };});
    }, _this.

    handleAdd = function () {
      _this.setState({ view: _contants2.default.newMessage });

      _reactScroll.scroller.scrollTo(_constants.TAB_PROJECT_ID.messageCompany, {
        duration: 250,
        offset: -250,
        smooth: true });

    }, _this.

    submitForm = function (_ref) {var message = _ref.message;
      _this.props.upsertMessage({
        token: _this.props.userToken,
        project_id: (0, _get2.default)(_this.props, 'projectDetails.id'),
        id: _this.state.selectedMessageId,
        message: message });

    }, _this.

    handleSubmit = function (event) {
      _this.setState({
        view: _contants2.default.messages,
        selectedMessageId: null });


      _this.props.initializeForm({ message: '' });
      _reactScroll.scroller.scrollTo(_constants.TAB_PROJECT_ID.messageCompany, {
        duration: 250,
        offset: -250,
        smooth: true });


      return _this.props.handleSubmit(_this.submitForm)(event);
    }, _this.

    handleDeleteMessage = function () {
      _this.props.deleteMessage({
        token: _this.props.userToken,
        project_id: _this.props.projectDetails.id,
        id: _this.state.selectedMessageId });

      _this.props.hideMessageModal();
      _this.setState({
        selectedMessageId: null,
        view: _this.props.messages.length <= 1 ? _contants2.default.empty : _contants2.default.messages });

    }, _this.

    handleCancelDelete = function () {
      _this.props.hideMessageModal();
      _this.setState({ selectedMessageId: null });
    }, _this.

    handleDelete = function (_ref2) {var id = _ref2.id;
      _this.setState({ selectedMessageId: id });
      return _this.props.
      openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('div', null,
            _react2.default.createElement('span', null, _this.props.translate('propertyDetails', 'delete')),
            _react2.default.createElement('div', { className: styles.modalButtonWrapper },
              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.handleDeleteMessage },

                _this.props.translate('propertyDetails', 'yes')),

              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.handleCancelDelete },

                _this.props.translate('propertyDetails', 'no'))))) });






    }, _this.

    handleEdit = function (_ref3) {var message = _ref3.message,id = _ref3.id;
      _this.props.initializeForm({ message: message });
      _this.setState({ view: _contants2.default.editMessage, selectedMessageId: id });
    }, _this.

    handleCancel = function () {
      _this.props.initializeForm({ message: '' });
      return _this.setState({
        view: (0, _isEmpty2.default)(_this.props.messages) ? _contants2.default.empty : _contants2.default.messages,
        selectedMessageId: null });

    }, _this.

    renderTextInput = function (_ref4) {var input = _ref4.input,placeholder = _ref4.placeholder;return (
        _react2.default.createElement('div', { className: styles.textareaWrapper },
          _react2.default.createElement(_OMTextArea2.default, _extends({
            maxLength: '250',
            rows: '3',
            placeholder: placeholder },
          input)),

          _react2.default.createElement('p', null, input.value.length || 0, ' / 250')));}, _this.



    renderMessageBlock = function () {var
      view = _this.state.view;var _this$props =
      _this.props,translate = _this$props.translate,submitting = _this$props.submitting,_this$props$messages = _this$props.messages,messages = _this$props$messages === undefined ? [] : _this$props$messages,isOwner = _this$props.isOwner;

      switch (view) {
        case _contants2.default.empty:
          return (
            _react2.default.createElement(_MessageBlock2.default, {
                subtitle: translate('propertyDetails', 'emptyMessageSubtitle'),
                title: translate('propertyDetails', 'emptyMessageTitle') },

              _react2.default.createElement('button', {
                  className: styles.emptyButton,
                  onClick: _this.handleAdd,
                  type: 'button' },

                _react2.default.createElement('i', { className: 'icon icon-add' }),
                _react2.default.createElement('span', null, translate('propertyDetails', 'emptyButton')))));




        case _contants2.default.newMessage:
          return (
            _react2.default.createElement(_MessageBlock2.default, {
                subtitle: translate('propertyDetails', 'emptyMessageSubtitle'),
                title: translate('propertyDetails', 'emptyMessageTitle') },

              _react2.default.createElement(_MessageForm2.default, {
                inputComponent: _this.renderTextInput,
                onSubmit: _this.handleSubmit,
                translate: translate,
                isRtl: false,
                loading: submitting,
                onCancel: _this.handleCancel })));



        case _contants2.default.editMessage:
          return (
            _react2.default.createElement(_MessageBlock2.default, {
                title: translate('propertyDetails', 'editMessageTitle') },

              _react2.default.createElement(_MessageForm2.default, {
                inputComponent: _this.renderTextInput,
                onSubmit: _this.handleSubmit,
                translate: translate,
                isRtl: false,
                loading: submitting,
                onCancel: _this.handleCancel })));




        default:
          return (
            _react2.default.createElement(_MessagesList2.default, {
              messages: messages,
              translate: translate,
              isOwner: isOwner,
              isOpen: _this.state.isOpen,
              onAdd: _this.handleAdd,
              onEdit: _this.handleEdit,
              onDelete: _this.handleDelete,
              onToggleMore: _this.handleClick }));}



    }, _temp), _possibleConstructorReturn(_this, _ret);}MessageFromCompanyComponent.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,messages = _props.messages,isOwner = _props.isOwner;

    if ((0, _isEmpty2.default)(messages) && !isOwner) return null;

    return (
      _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.messageCompany, className: styles.wrapper },
        _react2.default.createElement('p', { className: styles.title }, translate('propertyDetails', 'messageFromCompany')),
        _react2.default.createElement('div', { className: styles.messagesWrapper },
          this.renderMessageBlock())));



  };return MessageFromCompanyComponent;}(_react.Component);


MessageFromCompanyComponent.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  messages: _propTypes2.default.array,
  isOwner: _propTypes2.default.bool.isRequired,
  upsertMessage: _propTypes2.default.func,
  deleteMessage: _propTypes2.default.func,
  projectDetails: _propTypes2.default.object.isRequired,
  userToken: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func.isRequired,
  submitting: _propTypes2.default.bool,
  initializeForm: _propTypes2.default.func.isRequired,
  openMessageModal: _propTypes2.default.func.isRequired,
  hideMessageModal: _propTypes2.default.func.isRequired };exports.default =


MessageFromCompanyComponent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/MessageFromCompanyComponent.js
// module id = 2826
// module chunks = 0